import React, { useEffect, useState } from "react";
import { Flex } from "@chakra-ui/react";
import Sidebar from "./Sidebar";
import MainWindow from "./MainWindow";
import { AppContext } from "AppProvider/AppContext";
import { appRequest } from "routes";
import ToastNotification from "components/common/ToastNotification/ToastNotification";
import ErrorBoundary from "components/common/ErrorBoundary/ErrorBoundary";
import { calculateDateRange } from "App/BsesPoc/components/common/function";
import { useSearchParams } from "react-router-dom";
import { routePath } from "config/pathConstant";

function Dashboard(): JSX.Element {
  const [startDate, setStartDate] = useState<any>(() => {
    const date = new Date();
    date.setMonth(date.getMonth() - 9);
    return date;
  });
  const [selectedTransport, setSelectedTransport] = useState<any>(null);

  const [endDate, setEndDate] = useState<any>(() => new Date());
  const [updateDashboardApi, setUpdateDashboardApi] = useState(false);
  const [activePage, setActivePage] = useState<string>("Dashboard");
  const [activeWorkflow, setActiveWorkflow] = useState(null);
  const [workflowProcess, setWorkflowProcess] = useState({
    processName: "",
    processType: "",
  });
  const [openMobileSideDrawer, setOpenMobileSideDrawer] = useState(false);
  const [displaySidebar, setDisplaySidebar] = useState<boolean>(true);
  const [notify, toastNotify] = useState<any>(null);
  const [userWorkflows, setUserWorkflows] = useState<any>([]);
  const [selectedLevel, setSelectedLevel] = useState<any>(null);
  const [userRole, setUserRole] = useState<string[]>([""]);
  const [workFlowData, setWorkFlowData] = useState<any>({});
  const [companyType, setCompanyType] = useState<string>("");
  const [accountDetails, setAccountDetails] = useState<any>(null);
  const [license, setLicence] = useState<string>("");
  const [checkData, setCheckData] = useState<any>({
    workData: false,
    currentWorkApi: false
  });
  const [searchParams] = useSearchParams();
  const [defaultAbsent, setDefaultAbsent] = useState<boolean>(false);
  const [isAccountDetailsFetched, setIsAccountDetailsFetched] = useState(false);
  const documentId = searchParams.get("documentId");

  async function getAccountDetails() {
    let response: any = await appRequest("user", "getUserDetails");
    if (response && response.status !== "error") {
      setAccountDetails(response);
      setUserRole(response?.permission);
      setCompanyType(response?.company?.type);
      setLicence(response?.company?.licence);
      setIsAccountDetailsFetched(true);
      // getDefaultWorkFlow();

      if (documentId) {
        setActivePage('Approvals')
      }
    }
  }

  async function getUsersWorkFlows() {
    let response: any = await appRequest("workflow", "getWorkflows", { process: sessionStorage.getItem("process") });
    if (response && response?.data) {
      if (Array.isArray(response?.data)) {
        setUserWorkflows(response.data);
        if (response.data?.length === 0) {
          setCheckData((prev: any) => ({ ...prev, workData: true }));
        }
      }
    }
  }

  const setDefaultForeignUser = async (processName: any, processType: any) => {
    try {
      let response: any = await appRequest("workflow", "setStaticDefaultWorkflow", { processName, processType });
      if (response && response?.status === "success") {
        if (response?.hasData) {
          if (!sessionStorage.getItem('processIsCalled')) {
            sessionStorage.setItem('processIsCalled', 'true')
            window.location.reload();
          }
        }
      }
    }
    catch (err: any) {
    }
  }

  async function getDefaultWorkFlow() {
    let query: any = {};
    if (sessionStorage.getItem("activeWorkflowId")) {
      query["activeWorkflow"] = sessionStorage.getItem("activeWorkflowId");
      query['process'] = sessionStorage.getItem("process")
    }
    let response: any = await appRequest("workflow", "getDefault", query);
    if (response && response?.data && response?.status === "success") {
      setActiveWorkflow(response.data._id);
      setWorkFlowData({ ...response.data, ...response.data?.values, _id: response.data?._id });

      if (sessionStorage.getItem('process') === "foreign") {
        if (response?.data?.values?.processName !== "foreign") {
          await setDefaultForeignUser('foreign', 'NonPo')
        }
      }

      setWorkflowProcess({
        processName:
          response.data?.values?.processName || response?.data?.processName,
        processType:
          response.data?.values?.processType || response?.data?.processType,
      });
      // Match username with approvals and merge accountDetails
      if (accountDetails) {

        const user = accountDetails.userId;
        const matchedApproval = response?.data?.values?.approvals?.find(
          (approval: any) =>
            (approval?.user ? approval.user.toString() : "") === (user ? user.toString() : "")
        );

        if (matchedApproval) {
          setAccountDetails((prevDetails: any) => ({
            ...prevDetails,
            ...matchedApproval
          }));
        }
        getUsersWorkFlows();
      }
    } else {
      if (response?.data === "No WorkFlow Exists" && sessionStorage.getItem('process') === "foreign") {
        await setDefaultForeignUser('foreign', 'NonPo')
      }
      else {
        getUsersWorkFlows();
        setCheckData((prev: any) => ({ ...prev, api: true }));
        setDefaultAbsent(!defaultAbsent);
      }
    }
  }

  useEffect(() => {
    toastNotify({
      title: "Welcome Back!",
    });
    getAccountDetails();
  }, []);

  useEffect(() => {
    if (isAccountDetailsFetched) {
      getDefaultWorkFlow();
    }
  }, [isAccountDetailsFetched]);

  useEffect(() => {

    if (accountDetails?.allowWithoutWorkflow) {
      setActivePage(routePath.paymentInitiateDocument);
      return
    }
    if (
      Object.keys(workFlowData).length === 0 &&
      userWorkflows.length === 0 &&
      checkData.api &&
      checkData.workData &&
      accountDetails?.role !== "admin"
    ) {
      setDefaultAbsent(false);
      toastNotify({
        title: "Error: Oops! Something went wrong",
        type: "error",
      });
      setTimeout(() => {
        sessionStorage.removeItem("auth-token");
        window.location.href = "/";
      }, 2000);
    }
    if (
      Object.keys(workFlowData).length === 0 &&
      userWorkflows.length === 0 &&
      checkData.api &&
      checkData.workData &&
      accountDetails?.role === "admin"
    ) {
      setActivePage("WorkFlow");
    }
  }, [workFlowData, userWorkflows, checkData, accountDetails]);

  const handleActivePage = (e: any) => {
    const urlMap: { [key: string]: string } = {};
    if (workFlowData && workFlowData.tab) {
      workFlowData.tab.forEach((item: any) => {
        if (item.label && item.url) {
          urlMap[item.label] = item.url;
        }
      });
    }
    if (urlMap.hasOwnProperty(e)) {
      const url = urlMap[e];
      window.open(url, "_blank");
    } else {
      setActivePage(e);
    }
  };

  const resetDates = () => {
    let range: any = 9; // fallback

    if (
      workFlowData?.dateFilter?.range &&
      workFlowData?.dateFilter?.rangeActive
    ) {
      const parts = workFlowData.dateFilter.range.split("-");
      if (parts[1]) range = parseInt(parts[1], 10);
    }

    const { startDate: newStart, endDate: newEnd } = calculateDateRange(range);
    setStartDate(newStart);
    setEndDate(newEnd);
  };

  return (
    <AppContext.Provider
      value={{
        startDate,
        endDate,
        userRole,
        license,
        companyType,
        accountDetails,
        setAccountDetails,
        notify,
        toastNotify,
        workFlowData,
        getDefaultWorkFlow,
        getUsersWorkFlows,
        setUserWorkflows,
        userWorkflows,
        getAccountDetails,
        setActivePage,
        activePage,
        defaultAbsent,
        setActiveWorkflow,
        activeWorkflow,
        setDefaultAbsent,
        workflowProcess,
        setWorkflowProcess,
        setEndDate,
        setStartDate,
        resetDates,
        selectedLevel,
        setSelectedLevel,
        updateDashboardApi,
        setUpdateDashboardApi,
        selectedTransport,
        setSelectedTransport
      }}
    >
      <ErrorBoundary>
        <Flex>
          {displaySidebar ? (
            <Sidebar
              activePage={activePage}
              setActivePage={handleActivePage}
              openMobileSideDrawer={openMobileSideDrawer}
              setOpenMobileSideDrawer={setOpenMobileSideDrawer}
            />
          ) : null}
          <MainWindow
            workFlowData={workFlowData}
            activePage={activePage}
            setActivePage={handleActivePage}
            displaySidebar={displaySidebar}
            setDisplaySidebar={setDisplaySidebar}
            setOpenMobileSideDrawer={setOpenMobileSideDrawer}
          />
          <ToastNotification />
        </Flex>
      </ErrorBoundary>
    </AppContext.Provider>
  );
}

export default React.memo(Dashboard);
